import { createContext, ReactNode, useMemo } from "react";

import { TenantContextValue } from "@/types";

import {
  getRuntimeHostname,
  resolveTenantId,
  resolveTenantName,
} from "@/utils/tenant";

export const TenantContext = createContext<TenantContextValue | null>(null);

interface TenantProviderProps {
  children: ReactNode;
}

export const TenantProvider = ({ children }: TenantProviderProps) => {
  const value = useMemo<TenantContextValue>(() => {
    const hostname = getRuntimeHostname();
    const resolvedTenantId = resolveTenantId(
      hostname,
      import.meta.env.VITE_TENANT_ID,
    );
    const tenantId = resolvedTenantId;

    return {
      tenantId,
      tenantName: tenantId ? resolveTenantName(tenantId) : undefined,
      hostname,
      isResolved: Boolean(tenantId),
    };
  }, []);

  return (
    <TenantContext.Provider value={value}>{children}</TenantContext.Provider>
  );
};
